/**
 * カラコン商品一覧の画像種別をストアに保持し、 localStorage に永続化する
 * @see https://github.com/Everforth/growthpalette-front/issues/8656
 */
import { ImageAppKind } from '@/models/api/image'
import {
  ContactLensImageType as StoredContactLensImageType,
  DEFAULT_IMAGE_TYPE,
  loadContactLensImageType,
  saveContactLensImageType,
} from '@/services/contact-lens-image-type/contact-lens-image-type-storage'
import { Module } from 'vuex'

// 永続化と型はstoreを持たないバンドル(hl-itemlist)とも共有するためサービスに切り出している。
// 既存の参照元があるため、このモジュールからも公開する。
// 型を値の `export {}` でre-exportすると、transpileOnlyのts-loaderが実行時exportとしてemitしてしまい
// webpackの "export not found" 警告になるため、型はaliasで再宣言し、値のみre-exportする。
export type ContactLensImageType = StoredContactLensImageType
export { DEFAULT_IMAGE_TYPE }

const IMAGE_APP_KIND_MAP: Record<ContactLensImageType, string> = {
  worn: ImageAppKind.WornForListView,
  lens: ImageAppKind.Lens,
  package: ImageAppKind.Representative,
}

export function createContactLensImageType<R>(): Module<{ imageType: ContactLensImageType }, R> {
  return {
    namespaced: true,
    state: { imageType: loadContactLensImageType() },
    mutations: {
      setImageType(state, type: ContactLensImageType) {
        state.imageType = type
        saveContactLensImageType(type)
      },
    },
    getters: {
      imageAppKind: (state): string => IMAGE_APP_KIND_MAP[state.imageType] || ImageAppKind.WornForListView,
    },
  }
}
